<template>
  <div class="reset-password-modal">
    <Transition name="fade">
      <div v-if="open" class="modal">
        <a class="cancel" @click="close">
          <i class="icon material-icons">
            close
          </i>
        </a>
        <div class="logo">
          <Logo :text-in-mobile="true" />
        </div>
        <div class="content">
          <h1 class="title">
            {{ $t('AUTH.FORGET_PASSWORD') }}
          </h1>
          <h2 class="subtitle">
            {{ $t('AUTH.ENTRY_REGISTERED_EMAIL') }}
          </h2>
          <form class="form" @submit.prevent="submit">
            <label for="resetEmail">
              {{ $t('AUTH.ENTRY_EMAIL') }}
            </label>
            <input id="resetEmail" v-model="email" :class="{'error': msg}" type="text" placeholder="your-email-address@example.com">
            <div class="msg error">
              {{ msg }}
            </div>
          </form>
          <div class="control">
            <button class="mk-btn mk-btn--secondary" @click="close">
              {{ $t('COMMON.CANCEL') }}
            </button>
            <button :class="{'loading': loading}" class="mk-btn mk-btn--primary" @click="submit">
              {{ $t('COMMON.SEND') }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import Logo from '@/components/common/Logo'
import AuthService from '@/assets/services/AuthService'

export default {
  name: 'ResetPasswordModal',
  components: {
    Logo
  },
  directives: {},
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      email: '',
      msg: ''
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    close() {
      this.$emit('close')
    },
    async submit() {
      this.loading = true
      const reg = /\S+@\S+\.\S+/
      this.msg = ''
      if (!this.email) {
        this.msg = this.$t('AUTH.REQUIRED')
      } else if (!reg.test(this.email)) {
        this.msg = this.$t('AUTH.INVALID_EMAIL_ERROR')
      }
      if (!this.msg) {
        const res = await AuthService.requestResetEmail(this.email)
        if (res && res.status === 200) {
          this.$store.commit('ALERT_MESSAGE', { message: 'COMMON.SENT', type: 'success' })
          this.$emit('close')
        } else {
          this.$store.commit('ALERT_MESSAGE', { message: 'COMMON.NOT_FOUND', type: 'error', duration: 6000 })
          this.$nextTick(() => {
            this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.ENTRY_REGISTERED_EMAIL', type: 'error', duration: 6000 })
          })
        }
      }
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';

.reset-password-modal {
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #ffffff;
    .cancel {
      position: absolute;
      top: 36px;
      right: 36px;
      width: 36px;
      height: 36px;
      cursor: pointer;
      > i {
        font-size: 36px;
        color: $grey-7d;
      }
    }
    .logo {
      position: absolute;
      top: 19px;
      left: 36px;
    }
    .content {
      display: block;
      max-width: 720px;
      margin: 120px auto 0 auto;
      padding: 36px;
      .title {
        margin: 0 0 16px 0; // bottom 16px
        font-size: 48px;
        line-height: 48px;
        font-weight: 500;
        text-align: left;
        color: $grey-50;
      }
      .subtitle {
        margin: 0;
        font-size: 20px;
        font-weight: 500;
        line-height: 32px;
        text-align: left;
        color: $grey-7d;
      }
      form {
        margin: 60px 0;
        label {
          display: block;
          height: 32px;
          font-size: 20px;
          font-weight: 500;
          line-height: 32px;
          text-align: left;
          color: $grey-7d;
        }
        input {
          display: block;
          width: 100%;
          height: 55px;
          font-size: 20px;
          padding: 8px 16px;
          margin-bottom: 8px;
          border-radius: 4px;
          background-color: #ffffff;
          border: solid 1px $grey-7d;
          caret-color: $theme-yellow;
          outline: none;
          &::placeholder{
            color: $grey-9b;
          }
          &.error {
            border: solid 1px $btn-danger-color
          }
        }
        .msg {
          height: 18px;
        }
        .msg.error {
          height: 18px;
          margin: 8px 0;
          font-size: 12px;
          line-height: 18px;
          color: $btn-danger-color;
        }
      }
      .control {
        text-align: right;
        > button {
          margin: 16px 0 16px 16px;
        }
      }
    }
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {
  .reset-password-modal {
    .modal {
      .cancel {
        position: absolute;
        top: 24px;
        right: 24px;
        width: 24px;
        height: 24px;
        > i {
          font-size: 24px;
        }
      }
      .logo {
        position: absolute;
        top: 0;
        left: 24px;
      }
      .content {
        margin: 60px auto 0 auto;
        padding: 24px;
        form {
          margin: 24px 0;
        }
        .control {
          text-align: center;
          > button {
            width: 100%;
            margin: 16px 0;
          }
        }
      }
    }
  }
}
</style>
